import React, { useState } from "react";

const ShipmentBoxesReview = ({ boxes = [], isMobile = false }) => {
  const [expanded, setExpanded] = useState(false);
  const previewLimit = 4;
  const hasOverflow = boxes.length > previewLimit;
  const visibleBoxes = hasOverflow && !expanded ? boxes.slice(0, previewLimit) : boxes;
  const totalUnits = boxes.reduce(
    (sum, box) => sum + (box.box_items || []).reduce((itemSum, item) => itemSum + (Number(item.quantity) || 0), 0),
    0
  );

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
        {visibleBoxes.map((box, index) => {
          const units = (box.box_items || []).reduce((sum, item) => sum + (Number(item.quantity) || 0), 0);
          const dimension = box.box_dimension || {};
          const itemPreview = (box.box_items || [])
            .map((item) => `${item.item_name || item.name || "Item"} x${item.quantity}`)
            .join(", ");

          return (
            <div
              key={index}
              style={{
                display: "grid",
                gridTemplateColumns: isMobile ? "1fr" : "78px minmax(0, 1fr) 142px 72px",
                gap: isMobile ? 5 : 12,
                alignItems: isMobile ? "flex-start" : "center",
                padding: "10px 12px",
                borderRadius: 8,
                border: "1px solid rgba(255,255,255,0.07)",
                background: "rgba(255,255,255,0.018)",
              }}
            >
              <div style={{ color: "#fff", fontSize: 13, fontWeight: 700 }}>Box {index + 1}</div>
              <div
                style={{
                  minWidth: 0,
                  color: "#c3c8cc",
                  fontSize: 12.5,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: isMobile ? "normal" : "nowrap",
                }}
              >
                {itemPreview || "No items"}
              </div>
              <div style={{ color: "#c3c8cc", fontSize: 12, fontFamily: "ui-monospace, SF Mono, Menlo, monospace" }}>
                {dimension.length || "?"} x {dimension.width || "?"} x {dimension.height || "?"} in
                {" / "}
                {dimension.weight || "?"} lb
              </div>
              <div style={{ color: "#fff", fontSize: 12.5, fontWeight: 700, textAlign: isMobile ? "left" : "right" }}>
                {units} unit{units === 1 ? "" : "s"}
              </div>
            </div>
          );
        })}
      </div>

      {hasOverflow && (
        <button
          type="button"
          onClick={() => setExpanded((prev) => !prev)}
          style={{
            height: 34,
            borderRadius: 8,
            border: "1px solid rgba(255,255,255,0.08)",
            background: "rgba(255,255,255,0.025)",
            color: "#c3c8cc",
            fontSize: 12.5,
            fontWeight: 700,
            cursor: "pointer",
          }}
        >
          {expanded ? "Show fewer boxes" : `Show all ${boxes.length} boxes`}
        </button>
      )}

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "6px 2px 0",
          color: "#c3c8cc",
          fontSize: 13,
        }}
      >
        <span>
          {boxes.length} box{boxes.length === 1 ? "" : "es"}
        </span>
        <span style={{ color: "#fff", fontWeight: 700 }}>
          {totalUnits} unit{totalUnits === 1 ? "" : "s"}
        </span>
      </div>
    </div>
  );
};

export default ShipmentBoxesReview;
